"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FilterSelect = _interopRequireDefault(require("./FilterSelect"));

var _FilterInput = _interopRequireDefault(require("./FilterInput"));

var _OperatorSelect = _interopRequireDefault(require("./OperatorSelect"));

var _FilterDeleteButton = _interopRequireDefault(require("./FilterDeleteButton"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _Filters = require("AudienceTargetingUIComponents/constants/Filters");

var Filter =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Filter, _Component);
  (0, _createClass2.default)(Filter, null, [{
    key: "propTypes",
    get: function get() {
      return {
        filterIndex: _react.PropTypes.number.isRequired,
        disabledOperators: _react.PropTypes.array,
        filter: _react.PropTypes.object,
        filterOptions: _react.PropTypes.object,
        groupId: _react.PropTypes.string.isRequired,
        hasScope: _react.PropTypes.bool.isRequired,
        isFirst: _react.PropTypes.bool.isRequired,
        isShow: _react.PropTypes.bool,
        labelConfig: _react.PropTypes.object,
        removeEnabled: _react.PropTypes.bool,
        onBlur: _react.PropTypes.func.isRequired,
        onRemove: _react.PropTypes.func,
        upgradeConfig: _react.PropTypes.object.isRequired,
        updateFilter: _react.PropTypes.func.isRequired
      };
    }
  }]);

  function Filter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Filter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Filter).call(this, props));
    _this.getFilterOption = _this.getFilterOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.getOperators = _this.getOperators.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePropertyChange = _this.handlePropertyChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Filter, [{
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "getFilterOption",
    value: function getFilterOption(type) {
      var _this$props = this.props,
          filterOptions = _this$props.filterOptions,
          filter = _this$props.filter;
      return filterOptions[type || filter.get('type')];
    }
  }, {
    key: "getOperators",
    value: function getOperators() {
      var filterOption = this.getFilterOption();
      var options = filterOption ? filterOption.operators : [];
      return options && options.length > 1 ? options : null;
    }
  }, {
    key: "handlePropertyChange",
    value: function handlePropertyChange(property, value) {
      var _this$props2 = this.props,
          filter = _this$props2.filter,
          filterIndex = _this$props2.filterIndex,
          groupId = _this$props2.groupId,
          isShow = _this$props2.isShow,
          updateFilter = _this$props2.updateFilter,
          hasScope = _this$props2.hasScope;
      var type = filter.get('type');

      if (property === 'type' && !hasScope && _Filters.FILTERS[value].group === _Filters.FILTER_GROUPS.ALLVISITORS) {
        return;
      }

      updateFilter(filterIndex, groupId, property, value, isShow, type === 'URL');
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      var _this$props3 = this.props,
          filterIndex = _this$props3.filterIndex,
          onBlur = _this$props3.onBlur;
      onBlur([filterIndex]);
    }
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      var _this$props4 = this.props,
          isFirst = _this$props4.isFirst,
          labelConfig = _this$props4.labelConfig;

      var when = labelConfig.when || _I18n.default.text(this.getLangKey('when'));

      var or = labelConfig.or || _I18n.default.text(this.getLangKey('or'));

      var content = isFirst ? when : or;
      return _react.default.createElement("div", {
        className: "targeting-option__arrow"
      }, content);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          disabledOperators = _this$props5.disabledOperators,
          filter = _this$props5.filter,
          filterOptions = _this$props5.filterOptions,
          hasScope = _this$props5.hasScope,
          isShow = _this$props5.isShow,
          labelConfig = _this$props5.labelConfig,
          onRemove = _this$props5.onRemove,
          removeEnabled = _this$props5.removeEnabled,
          upgradeConfig = _this$props5.upgradeConfig;
      var operators = this.getOperators();
      var hideClass = "" + (!isShow && 'hide-group');
      var values = filter.get('values');
      var hasValues = values || values === false;
      var hasDelete = removeEnabled || filter.get('type') !== 'URL' && hasValues;
      return _react.default.createElement(_UIMultiColumn.default, {
        className: "targeting-option"
      }, _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        className: "targeting-option__rule " + hideClass
      }, this.renderArrow(), _react.default.createElement(_FilterSelect.default, {
        hasScope: hasScope,
        labelConfig: labelConfig,
        options: filterOptions,
        value: filter.get('type'),
        onChange: function onChange(e) {
          return _this2.handlePropertyChange('type', e.target.value);
        },
        upgradeConfig: upgradeConfig
      }), !operators && !filter.get('type') ? _react.default.createElement("span", {
        className: "filter__optional"
      }, _I18n.default.text(this.getLangKey('filter.optional'))) : null, operators ? _react.default.createElement(_OperatorSelect.default, {
        options: operators,
        disabledOptions: disabledOperators,
        labelConfig: labelConfig,
        value: filter.get('operator'),
        onChange: function onChange(e) {
          return _this2.handlePropertyChange('operator', e);
        }
      }) : null, filter.get('type') ? _react.default.createElement(_FilterInput.default, {
        labelConfig: labelConfig,
        type: filter.get('type'),
        operator: filter.get('operator'),
        value: filter.get('values'),
        size: operators ? '' : 'long',
        onChange: function onChange(value) {
          return _this2.handlePropertyChange('values', value);
        },
        onBlur: function onBlur() {
          return _this2.handleInputBlur();
        }
      }) : null, hasDelete && _react.default.createElement(_FilterDeleteButton.default, {
        onClick: onRemove
      }))));
    }
  }]);
  return Filter;
}(_react.Component);

exports.default = Filter;
module.exports = exports.default;